import cx from 'classnames';

import { FooterTop } from './components/FooterTop/FooterTop';
import { FooterSocials } from './components/FooterSocials/FooterSocials';
import { FooterProducts } from './components/FooterProducts/FooterProducts';
import { FooterSupport } from './components/FooterSupport/FooterSupport';
import { FooterCompany } from './components/FooterCompany/FooterCompany';
import { FooterRegulatoryFramework } from './components/FooterRegulatoryFramework/FooterRegulatoryFramework';

import styles from './LandingFooter.module.sass';

export type FooterStyle = 'black' | 'white' | 'black-transparent';

interface LandingFooterProps {
  type?: FooterStyle;
  className?: string;
}

export const LandingFooter = ({
  type = 'black',
  className,
}: LandingFooterProps) => {
  const classes = cx(styles.footer, `${styles[`footer--${type}`]}`, className);

  return (
    <footer className={classes}>
      <div className={styles.wrapper}>
        <FooterTop type={type} />

        <div className={styles.nav}>
          <FooterProducts />
          <FooterCompany />
          <FooterSocials />
        </div>

        <div className={styles.bottom}>
          <div className={styles.copy}>
            © {`${new Date().getFullYear()}`} AMLBot
          </div>

          <FooterSupport />

          <FooterRegulatoryFramework />
        </div>
      </div>
    </footer>
  );
};
